import React, { Suspense, lazy } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/context/ProtectedRoute";
import SiteLayout from "@/components/layout/SiteLayout";
import AdminLayout from "@/components/layout/AdminLayout";
import { Toaster } from "@/components/ui/sonner";

const Home = lazy(() => import("@/pages/Home"));
const About = lazy(() => import("@/pages/About"));
const Services = lazy(() => import("@/pages/Services"));
const Work = lazy(() => import("@/pages/Work"));
const Clients = lazy(() => import("@/pages/Clients"));
const PodcastStudio = lazy(() => import("@/pages/PodcastStudio"));
const AISolutions = lazy(() => import("@/pages/AISolutions"));
const Blogs = lazy(() => import("@/pages/Blogs"));
const BlogDetail = lazy(() => import("@/pages/BlogDetail"));
const Contact = lazy(() => import("@/pages/Contact"));
const CostCalculatorPage = lazy(() => import("@/pages/CostCalculatorPage"));

const AdminLogin = lazy(() => import("@/pages/admin/Login"));
const AdminDashboard = lazy(() => import("@/pages/admin/Dashboard"));
const AdminServices = lazy(() => import("@/pages/admin/ServicesManager"));
const AdminPortfolio = lazy(() => import("@/pages/admin/PortfolioManager"));
const AdminClients = lazy(() => import("@/pages/admin/ClientsManager"));
const AdminTestimonials = lazy(() => import("@/pages/admin/TestimonialsManager"));
const AdminBlogs = lazy(() => import("@/pages/admin/BlogsManager"));
const AdminLeads = lazy(() => import("@/pages/admin/LeadsManager"));
const AdminPackages = lazy(() => import("@/pages/admin/PackagesManager"));
const AdminSettings = lazy(() => import("@/pages/admin/SiteSettingsPage"));

const Loader = () => (
  <div className="min-h-screen flex items-center justify-center bg-[#030712] text-blue-400">
    <div className="rr-pulse text-sm tracking-widest uppercase">Loading…</div>
  </div>
);

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Suspense fallback={<Loader />}>
            <Routes>
              <Route element={<SiteLayout />}>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/services" element={<Services />} />
                <Route path="/work" element={<Work />} />
                <Route path="/clients" element={<Clients />} />
                <Route path="/podcast" element={<PodcastStudio />} />
                <Route path="/ai-solutions" element={<AISolutions />} />
                <Route path="/blogs" element={<Blogs />} />
                <Route path="/blogs/:slug" element={<BlogDetail />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/cost-calculator" element={<CostCalculatorPage />} />
              </Route>

              <Route path="/admin/login" element={<AdminLogin />} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <AdminLayout />
                  </ProtectedRoute>
                }
              >
                <Route index element={<AdminDashboard />} />
                <Route path="services" element={<AdminServices />} />
                <Route path="portfolio" element={<AdminPortfolio />} />
                <Route path="clients" element={<AdminClients />} />
                <Route path="testimonials" element={<AdminTestimonials />} />
                <Route path="blogs" element={<AdminBlogs />} />
                <Route path="leads" element={<AdminLeads />} />
                <Route path="packages" element={<AdminPackages />} />
                <Route path="settings" element={<AdminSettings />} />
              </Route>
            </Routes>
          </Suspense>
          <Toaster theme="dark" position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
